import React, { useState } from "react";

const SelectYear = ({ onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
  const filteredYears = years.filter((year) =>
    year.toString().includes(searchQuery)
  );

  return (
    <>
      <section
        style={{
          fontFamily: "Barlow Condensed",
          height: "40rem",
          maxHeight: "90vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="overflow-y-auto"
      >
        <h4
          style={{ fontFamily: "Ballega" }}
          className="text-center text-2xl sm:text-3xl mb-8"
        >
          Select the Year of Manufacture
        </h4>
        <div className="relative mb-8 flex justify-center items-center">
          <input
            type="search"
            placeholder="SEARCH FOR THE BRAND"
            aria-label="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full px-4 py-4 text-center placeholder-gray font-bold text-lg border border-black rounded-lg text-sm focus:ring focus:ring-black-200 focus:outline-none"
          />
          <span className="absolute right-96 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-5 h-5 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M9 16a7 7 0 100-14 7 7 0 000 14z"
              />
            </svg>
          </span>
        </div>
        <div
          className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-8 sm:px-16"
          style={{ fontFamily: "Ballega" }}
        >
          {filteredYears.map((year) => (
            <button
              key={year}
              className="p-4 text-xl sm:text-4xl border border-black rounded-md hover:bg-sky-300"
              onClick={() => onSelect("year", year)}
            >
              {year}
            </button>
          ))}
        </div>
      </section>
    </>
  );
};

export default SelectYear;
